import React from 'react';
import { Link } from 'react-router-dom';
import { FlameIcon } from 'lucide-react';
export const Header: React.FC = () => {
  return <header className="bg-background-light py-4 px-6 flex justify-between items-center shadow-lg" data-id="element-62">
      <Link to="/" className="flex items-center gap-2 text-primary font-bold text-2xl" data-id="element-63">
        <FlameIcon className="h-8 w-8" data-id="element-64" />
        <span data-id="element-65">IBD Rant</span>
      </Link>
      <nav className="flex gap-4 items-center" data-id="element-66">
        <Link to="/" className="text-text-primary hover:text-primary transition-colors" data-id="element-67">
          Home
        </Link>
        <Link to="/hall-of-rage" className="text-text-primary hover:text-primary transition-colors" data-id="element-68">
          Hall of Rage
        </Link>
        <Link to="/blog" className="text-text-primary hover:text-primary transition-colors" data-id="element-69">
          Blog
        </Link>
        <Link to="/resources" className="text-text-primary hover:text-primary transition-colors" data-id="element-70">
          Shopping
        </Link>
      </nav>
    </header>;
};